module.exports = __webpack_public_path__ + "img/ic_jr.2cd97d1e.png";